<ng-container *transloco="let t">
    <form [formGroup]="form" class="w-full">
      <formly-form [form]="form" [model]="model" [fields]="fields"></formly-form>
    </form>
</ng-container>
